import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CustomNavbar from "../../../components/CustomNavbar";
//import SibebarSeleccionContratacion from "../../../components/seleccionContratacion/SibebarSeleccionContratacion";
import comp from "../../../images/Modulo carrera y sucesion/pngegg.png";
import { Link } from "react-router-dom";
import SidebarPlanCarrera from "../../../components/planCarrera/SidebarPlanCarrera";

const Admin = () => {
  const [show, setShow] = useState(true);
  //* Method
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarPlanCarrera show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="jumbotron ft-banner">
            <main>
              <h1>Plan de Carrera</h1>
              <p className="mb-4 text-muted">
                El módulo de carrera tiene por objetivo la
                visualización de automatizar el proceso de planes de carrera de
                todos los colaboradores{" "}
              </p>
              <Row>
                <Col>
                  <h4>Mantenimientos plan de carrera</h4>
                  <ul className="ml-3 p-0">
                    
                    {/* <li>
                      <Link to="/sucesion/criticidad">
                        Mantenimiento de criticidad
                      </Link>
                    </li> */}
                    
                    <li>
                      <Link to="/plan-carrera/cursos">
                        Mantenimiento de cursos
                      </Link>
                    </li>
                    <li>
                      <Link to="/plan-carrera/cursos-funcion">
                        Mantenimiento de cursos función
                      </Link>
                    </li>
                    <li>
                      <Link to="/plan-carrera/competencias">
                        Mantenimiento de competencias
                      </Link>
                    </li>
                    <li>
                      <Link to="/plan-carrera/competencias-funcion">
                        Mantenimiento de competencias función
                      </Link>
                    </li>
                  
                    
                  </ul>
                </Col>
              </Row>
            </main>
            <div className="figure">
              <img src={comp} alt="descriptores y perfiles" className="my-3" />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Admin;
